/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_Confirm_All_HintInputs */



/**
* | output |
* | --- |
* | "Pauses for approval before each action, even reading." |
*
* @param {Agent_Builder_Confirmation_Confirm_All_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_confirm_all_hint = /** @type {((inputs?: Agent_Builder_Confirmation_Confirm_All_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_Confirm_All_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wartet vor jeder Aktion auf Freigabe, auch beim Lesen.")
	return /** @type {LocalizedString} */ ("Pauses for approval before each action, even reading.")
});